/**
 * Template Loader
 *
 * Handles loading and caching of HTML templates.
 * In development, templates are loaded dynamically.
 * In production, templates should be bundled as strings.
 */

// Import templates as raw strings (requires proper bundler configuration)
// For tsup: .html files configured as 'text' loader in tsup.config.ts
import authorizationTemplate from './html/authorization.html'
import confirmTxTemplate from './html/confirm-tx.html'
import readyIndicatorTemplate from './html/ready-indicator.html'
import signEip712TxTemplate from './html/sign-eip712-tx.html'
import passkeyConfirmTemplate from './html/passkey-confirm.html'

export class TemplateLoader {
  private static templateCache: Map<string, string> = new Map()

  /** Get template by name */
  static getTemplate(name: string): string {
    // Check cache first
    if (this.templateCache.has(name)) {
      return this.templateCache.get(name)!
    }

    // Load from bundled templates
    const template = this.loadBundledTemplate(name)

    if (!template) {
      throw new Error(`Template not found: ${name}`)
    }

    // Cache for future use
    this.templateCache.set(name, template)
    return template
  }

  /** Load bundled template */
  private static loadBundledTemplate(name: string): string | null {
    switch (name) {
      case 'authorization':
        return authorizationTemplate

      case 'ready-indicator':
        return readyIndicatorTemplate

      case 'sign-eip712-tx':
        return signEip712TxTemplate

      case 'confirm-tx':
        return confirmTxTemplate

      case 'passkey-confirm':
        return passkeyConfirmTemplate

      default:
        return null
    }
  }

  // /** Pre-load all templates (optional optimization) */
  // static preloadTemplates(): void {
  //   this.getTemplate('authorization')
  //   console.log('[TemplateLoader] Pre-loaded all templates')
  // }

  // /** Clear template cache (useful for hot-reloading in development) */
  // static clearCache(): void {
  //   this.templateCache.clear()
  //   console.log('[TemplateLoader] Cleared template cache')
  // }
}
